export function parseTrimmedString(value) {
  return String(value ?? '').trim();
}

export function parseCommaSeparatedInts(value) {
  if (!value) {
    return [];
  }
  return String(value)
    .split(',')
    .map(s => s.trim())
    .filter(Boolean)
    .map(s => parseInt(s, 10))
    .filter(n => !Number.isNaN(n));
}

export function parseCommaSeparatedStrings(value) {
  if (!value) {
    return [];
  }
  return String(value)
    .split(',')
    .map(s => s.trim())
    .filter(Boolean);
}

export function commaSeparatedIntsForQueryParam(ids) {
  let sorted = [...new Set(ids)].sort((a, b) => a - b);
  return sorted.length ? sorted.join(',') : null;
}

export function commaSeparatedStringsForQueryParam(ids) {
  let sorted = [...new Set(ids.map(String))].sort((a, b) => a.localeCompare(b));
  return sorted.length ? sorted.join(',') : null;
}

export function parseBooleanQueryParam(value) {
  return value === true || value === 'true';
}

export function booleanForQueryParam(value) {
  return parseBooleanQueryParam(value) ? true : null;
}
